/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETEXPERIENCEBYUSERID= createAsyncThunk(
  "getExperiencesByUserId/getExperiencesByUserId",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getExperiencesByUserIdSlice = createSlice({
  name: "getExperiencesByUserIdSlice",
  initialState: {
    getExperiencesByUserId: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetExperiencesByUserId: (state) => {
        state.getExperiencesByUserId.loading = false
        state.getExperiencesByUserId.error = false
        state.getExperiencesByUserId.data = []
        state.getExperiencesByUserId.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETEXPERIENCEBYUSERID.fulfilled, (state, action) => {
      state.getExperiencesByUserId = {
        ...state.getExperiencesByUserId,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEXPERIENCEBYUSERID.pending, (state, action) => {
      state.getExperiencesByUserId = {
        ...state.getExperiencesByUserId,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEXPERIENCEBYUSERID.rejected, (state, action) => {
      state.getExperiencesByUserId = {
        ...state.getExperiencesByUserId,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getExperiencesByUserIdAction = {
    GETEXPERIENCEBYUSERID,
};

export { getExperiencesByUserIdAction };
export default getExperiencesByUserIdSlice.reducer;
export const {setInitialStateOfgetExperiencesByUserId} = getExperiencesByUserIdSlice.actions